export class EmissionFactor {
  id: number;
  item: string;
  itemType: string;
  unit: string;
  kgCO2e_litre: string;
  kgCO2e_km: string;
  kgCO2e_kg: string;
  kgCO2e_kwh: string;
  kgCO2e_Gj: string;
  kgCO2e_tonnes: string;
  Fiscal_Year: string;
  manageScopeID: number;
  DataScopeID: number;
  vehicleTypeID: number;
  subCategorySeedID: number;
  subCatTypeID: number;
  regionID: number;
  regionName: string;
}